<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'
import AdkButton from '@components/ui/AdkButton.vue'
import { useLocale } from '@composables/useLocale'
import { useGtm } from '@composables/useGtm';
import { GTMContentGroup } from '@lib/models/gtm';

defineEmits<{
  action: [action: 'confirm' | 'cancel']
}>()
const props = defineProps<{ data: { countdown: number } }>()

const { t } = useLocale()
const { trackPageView, trackOnCloseModal } = useGtm()

const secondsLeft = ref(props.data.countdown)

onMounted(async () => {
  trackPageView({
    cg: GTMContentGroup.primary.USER,
    cg2: GTMContentGroup.secondary.INACTIVITY
  }, true)
  for (let i = secondsLeft.value - 1; i >= 0; i--) {
    await new Promise((resolve) => setTimeout(resolve, 1000))
    secondsLeft.value = i
  }
})

onBeforeUnmount(() => {
  trackOnCloseModal()
})
</script>

<template>
  <section
    data-test="slot-inactivity"
    class="px-vw-96 flex flex-col items-center gap-[calc(88*var(--vh))] pb-32"
  >
    <div class="gap-vh-56 flex w-[78.98vw] flex-col items-center">
      <img
        class="h-[calc(144*var(--vh))] w-[calc(144*var(--vw))]"
        src="/images/navigation/warning.svg"
        :alt="t('necesitas_mas_tiempo')"
      />
      <div class="gap-vh-24 flex flex-col text-center">
        <h1 data-test="slot-dialog_title" class="text-h1 font-bold">
          {{ t('necesitas_mas_tiempo') }}
        </h1>
        <p data-test="slot-dialog_description" class="text-h3">
          {{ t('continua_para_no_perder_tu_carrito') }}
        </p>
        <span data-test="slot-dialog_countdown" class="mt-vh-32 text-h1 block font-bold">
          {{ secondsLeft }}
        </span>
      </div>
    </div>
    <div class="gap-vw-24 px-vw-32 flex w-full">
      <AdkButton class="w-1/2" size="large" @press="$emit('action', 'cancel')">{{
        t('Cancelar_pedido')
      }}</AdkButton>
      <AdkButton class="w-1/2" size="large" is-primary @press="$emit('action', 'confirm')">{{
        t('si_continuar')
      }}</AdkButton>
    </div>
  </section>
</template>
